<template>
    <input-field v-bind="$attrs" :label="label" v-model="value" :rules="rules"  />
</template>

<script>
    import InputField from "../components/InputField";
    export default {
        name: "PhoneNumber",
        props: {
            label: {
                type: String
            },
            value: {
                type: String
            },
            rules: {
                default: []
            }
        },
        watch: {
            value() {
                this.$emit('input', this.value);
            }
        },
        components: {InputField}
    }
</script>

<style scoped>

</style>